<script>
import { cloneDeep } from 'lodash-es';
import ItineraryPricesPriceSettingsHotelModal from './ItineraryPricesPriceSettingsHotelModal';
import ItineraryPricesPriceSettingsSupplierModal from './ItineraryPricesPriceSettingsSupplierModal';
import ItineraryPricesPriceSettingsDiscountModal from './ItineraryPricesPriceSettingsDiscountModal';
import ItineraryPricesCategories from '../../../variables/itineraryPrices/itineraryPricesCategories';

export default {
  name: 'ItineraryPricesPriceSettingsTableRow',
  components: {
    ItineraryPricesPriceSettingsHotelModal,
    ItineraryPricesPriceSettingsSupplierModal,
    ItineraryPricesPriceSettingsDiscountModal,
  },
  props: {
    props: {
      type: Object,
      required: false,
    },
    extendedRow: {
      type: Boolean,
      default: false,
    },
    extraRow: {
      type: Boolean,
      default: false,
    },
    packageRow: {
      type: Boolean,
      default: false,
    },
    paxHeaders: {
      type: Array,
      required: true,
    },
    ageDiscountPaxes: {
      type: Array,
      default: () => [],
    },
    setting: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    hotelIndex: {
      type: Number,
      default: 0,
    },
    day: {
      type: Number,
      default: null,
    },
    date: {
      type: String,
      default: '',
    },
    availableHotels: {
      type: Array,
      default: () => [],
    },
    suppliers: {
      type: Array,
      required: true,
    },
    priceSettings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      localSetting: null,
      isGroup: false,
      localFilteredPrices: [],
      localPackageSupplier: null,
    };
  },
  watch: {
    setting: {
      deep: true,
      immediate: true,
      handler(value) {
        this.localSetting = cloneDeep(value);
        if (this.paxHeaders) {
          this.filteredPrices(this.paxHeaders);
        }
      },
    },
    localSetting: {
      deep: true,
      handler() {
        this.$emit('update', this.localSetting);
      },
    },
    paxHeaders: {
      deep: true,
      immediate: true,
      handler(value) {
        this.filteredPrices(value);
      },
    },
  },
  computed: {
    formattedDate() {
      if (this.date) {
        return this.$moment(this.date, 'YYYY-MM-DD').format('DD/MM YYYY');
      }
      return null;
    },
  },
  methods: {
    setHotelAndRoom(value) {
      this.localSetting.site = value.hotel;
      if (value.room) {
        this.localSetting.accommodation = value.room;
        this.localSetting.accommodationSiteId = value.room.accommodationSiteId;
        this.setSupplier(value.room.supplier);
      }
      this.priceSettings.hotels.forEach((hotel, index) => {
        if (hotel.site) {
          if (index !== this.index && hotel.site.siteId === value.hotel.siteId) {
            this.localSetting.category = ItineraryPricesCategories.CATEGORY_A;
            this.localSetting.included = true;
          }
        }
      });
      this.$emit('auto-set-site', value);
    },
    setSupplier(supplier) {
      this.localSetting.setting.supplier = supplier;
    },
    saveDiscounts(value) {
      this.$emit('setDiscounts', { siteIndex: this.hotelIndex, discounts: value });
    },
    filteredPrices(paxes) {
      let filteredPrices = [];
      paxes.forEach((paxHeader) => {
        const paxValues = paxHeader.text.split('-');
        this.isGroup = paxValues.length > 1;
      });

      if (this.isGroup) {
        filteredPrices = this.localSetting.setting.prices.filter(price => price.paxFrom !== price.paxTo);
      } else {
        filteredPrices = this.localSetting.setting.prices.filter(price => price.paxFrom === price.paxTo);
      }
      this.localFilteredPrices = filteredPrices.sort((a, b) => a.priceKey - b.priceKey);
    },
    setPrice(key, value) {
      this.localSetting.setting.prices.forEach((element) => {
        if (key === element.priceKey) {
          element.price = value !== '' ? +value : null;
        }
      });
      const noPrices = this.localSetting.setting.prices.every(element => element.price === null);
      if (this.localSetting.setting.accommodation && !noPrices) {
        this.localSetting.setting.supplier = this.localSetting.setting.accommodation.supplier;
      }
      if (noPrices) {
        this.$emit('no-prices');
      }
    },
    setMinCurrency(event) {
      this.localSetting.setting.currency.min = this.getInfo(event.target.value);
    },
    setMaxCurrency(event) {
      this.localSetting.setting.currency.max = this.getInfo(event.target.value);
    },
    setSingleRoomSupplement(value) {
      this.localSetting.singleRoomSupplementPrice = this.getInfo(value);
    },
    getInfo(value) {
      return value !== '' ? +value : null;
    },
    updateInfo(value, attribute) {
      this.localSetting.setting[attribute] = this.getInfo(value);
    },
    resetPrices() {
      const resetPrices = this.localSetting.setting.prices.map(({ price, ...prices }) => ({ ...prices, price: null }));
      this.localSetting.setting.prices = [...resetPrices];
      this.filteredPrices(this.paxHeaders);
    },
  },
};
</script>

<template>
  <tr class="text-xs-left">
    <td class="text-xs-left ma-0 pa-0">
      <div v-if="!extraRow && !packageRow">
        {{ day + 1 }} | {{ formattedDate }}
      </div>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <v-checkbox
        v-if="!packageRow"
        v-model="localSetting.included"
        :disabled="extraRow"
        class="pt-2"
        hide-details
      />
    </td>
    <td class="text-xs-center ma-0 pa-0">
      <template v-if="!packageRow && !extraRow">
        <itinerary-prices-price-settings-hotel-modal
          v-if="availableHotels.length"
          :hotels="availableHotels"
          :price-settings="priceSettings"
          :index="index"
          :hotel-index="hotelIndex"
          :date="date"
          :site="localSetting.site"
          :accommodation="localSetting.accommodation"
          @update="setHotelAndRoom($event)"
        />
      </template>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <div v-if="!packageRow && !extraRow && availableHotels.length">
        <span v-if="localSetting.site"> {{ localSetting.site.name }} </span>
        <span v-else>Select hotel</span>
        <br />
        <span v-if="localSetting.accommodation">
          {{ localSetting.accommodation.name.concat(
              ' (',
              localSetting.accommodation.maxAges.join(', ').replace(/999/g, 'A'),
              ')')
          }}
        </span>
        <span v-else>Select room</span>
      </div>
      <div v-if="extraRow">
        {{ localSetting.name }}
      </div>
      <div v-if="packageRow">
        {{ localSetting.category }}
      </div>
      <div v-if="!packageRow && !extraRow && !availableHotels.length && priceSettings.description">
        {{ priceSettings.description }}
      </div>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <div v-if="!packageRow && !extraRow">
        <select
          v-model="localSetting.category"
          :disabled="extraRow"
          name="classSelection"
          class="table-input"
        >
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
        </select>
      </div>
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.singleRoomSupplementPrice"
        type="number"
        step="0.01"
        class="table-input"
        @input="setSingleRoomSupplement($event.target.value)"
      />
    </td>
    <td
      v-for="(localFilteredPrice, index) in localFilteredPrices"
      :key="`customer-pax-headers-${index}`"
      class="text-xs-left ma-0 pa-0"
    >
      <input
        @input="setPrice(localFilteredPrice.priceKey, $event.target.value)"
        :value="localFilteredPrice.price"
        type="number"
        step="0.01"
        class="table-input"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.commissionRatio"
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'commissionRatio')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.contributionRatio"
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'contributionRatio')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.supplierGrossPrice"
        disabled
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'supplierGrossPrice')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.pricePerPerson"
        disabled
        type="number"
        step="0.01"
        class="table-input"
        @input="updateInfo($event.target.value, 'pricePerPersonExchanged')"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.currency.min"
        type="number"
        step="0.01"
        class="table-input"
        @input="setMinCurrency"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <input
        :value="localSetting.setting.currency.max"
        type="number"
        step="0.01"
        class="table-input"
        @input="setMaxCurrency"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <itinerary-prices-price-settings-discount-modal
        :discount-paxes="localSetting.setting.discounts"
        @update="saveDiscounts($event)"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <itinerary-prices-price-settings-supplier-modal
        :suppliers="suppliers"
        :selected-supplier="localSetting.setting.supplier"
        @update="setSupplier($event)"
        @reset-prices="resetPrices"
      />
    </td>
    <td class="text-xs-left ma-0 pa-0">
      <v-icon
        v-if="extendedRow"
        :disabled="extraRow"
        color="red darken-2"
        @click="$emit('delete', index)"
      >
        delete
      </v-icon>
      <div v-if="!extendedRow && !packageRow">
        <div @click="props.expanded = !props.expanded" class="expander">
          <v-icon v-if="!props.expanded">expand_more</v-icon>
          <v-icon v-else>expand_less</v-icon>
        </div>
      </div>
    </td>
  </tr>
</template>

<style scoped lang="scss">
  @import '../../../assets/scss/variables';

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .table-input {
    width: $prices-table-input-width;
    height: $prices-table-input-height;
    -moz-appearance: textfield;
    border: 1px solid $brand-grey-light;
    border-radius: $border-radius-xs;
    outline: none;
    text-align: center;

    &:disabled {
      background-color: #f8f8f8;
      color: #4e4e4e;
    }
  }

  .expander {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingsTableRow.vue